import React, { useContext, useState, useEffect } from "react";
import { ThemeContext } from "../../lib/main-context";
import { useTranslation } from "../../i18n/TranslationProvider";

import { useHistory } from "react-router-dom";

import theme from "../../index.scss";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import SubmitButton from "../UIComponents/SubmitButton";
import ComponentWrapper from "./ComponentWrapper";
import SendMessage from "./SendMessage";
import MyCustomDropdown from "../UIComponents/MyCustomDropdown";

import { updateMessageRead } from "../../api/messageRequests";

import useWindowSize from "../../lib/useWindowSize";

const Messages = ({ user, messages, setMessages, loadingMessages }) => {
  const { t } = useTranslation();
  const { dark } = useContext(ThemeContext);

  const [curReceiverId, setCurReceiverId] = useState(null);

  useEffect(() => {
    const recipients = user.messageRecipient;
    if (recipients && recipients.length > 0) {
      setCurReceiverId(recipients[0].receiver_id);
    }
  }, [user.messageRecipient]);

  const messagesForCurPatient = curReceiverId
    ? messages.filter((m) => m.otherUserId === curReceiverId)
    : [];

  const tenMessages = messagesForCurPatient;
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const history = useHistory();
  const [width] = useWindowSize();

  const setMessageAsRead = ({ messageId }) => {
    updateMessageRead({ messageId })
      .then(() => {
        setMessages((originalMessages) => {
          const newMessages = JSON.parse(JSON.stringify(originalMessages));
          const messageIndex = originalMessages.findIndex(
            (message) => message.messageId === messageId
          );
          newMessages[messageIndex].hasBeenRead = true;
          return newMessages;
        });
      })
      .catch((err) => {
        console.error(err);
        history.push("/oops");
      });
  };

  let messagesDisplay;

  const otherUserName = (message) =>
    message.otherUserFirstName + " " + message.otherUserLastName;

  const columns = [
    { dataField: "messageId", hidden: "true" },
    {
      dataField: "sentOrReceived",
      text: t("messages.table.sent_or_received.label"),
      formatter: (value) => t(`messages.table.sent_or_received.${value}`),
    },
    {
      dataField: "otherUserLastName",
      text: t("messages.table.other_user"),
      formatter: (value, row) =>
        row.otherUserFirstName + " " + row.otherUserLastName,
    },
    {
      dataField: "body",
      text: t("messages.table.message"),
    },
    {
      dataField: "date",
      text: t("messages.table.time"),
    },
    {
      dataField: "hasBeenRead",
      text: t("messages.table.status.label"),
      formatter: (hasBeenRead, row) => {
        return !hasBeenRead ? (
          <SubmitButton
            centered
            onClick={() => {
              setMessageAsRead({ messageId: row.messageId });
            }}
          >
            {t("messages.table.status.mark_as_read")}
          </SubmitButton>
        ) : (
          t("messages.table.status.have_read")
        );
      },
    },
  ];

  const rowStyle2 = (row, rowIndex) => {
    const style = {};
    style.overflowWrap = "break-word";
    if (!row.hasBeenRead) {
      style.backgroundColor = "#cfe8e6";
    }
    return style;
  };

  if (width >= 768) {
    messagesDisplay = tenMessages ? (
      <BootstrapTable
        class="overflow-hidden"
        keyField="messageId"
        data={tenMessages}
        columns={columns}
        pagination={paginationFactory()}
        rowStyle={rowStyle2}
      />
    ) : null;
  } else {
    messagesDisplay =
      tenMessages &&
      tenMessages.map((message) => (
        <Row className="font-weight-normal">
          <Col
            className={`mb-3 border border-dark rounded${!message.hasBeenRead ? " table-info font-weight-bold" : ""}`}
          >
            <h4 className="text-center">{otherUserName(message)}</h4>
            <h4 className="text-center">
              {message.sentOrReceived === "sent"
                ? t("messages.mobile.sent")
                : t("messages.mobile.received")}
            </h4>
            <h4 className="text-center">{message.date}</h4>
            <p>{message.body}</p>
            {!message.hasBeenRead && (
              <SubmitButton
                centered
                onClick={() => {
                  setMessageAsRead({ messageId: message.messageId });
                }}
              >
                {t("messages.table.status.mark_as_read")}
              </SubmitButton>
            )}
          </Col>
        </Row>
      ));
  }

  const handleDropdownChange = (selectedOption) => {
    const value = selectedOption ? selectedOption.value : "";
    setCurReceiverId(value);
  };

  const options = user?.messageRecipient?.map((r) => ({
    value: r.receiver_id,
    label: `${r.first_name} ${r.last_name}`,
  }));

  const unreadUserIds = messages
    ?.filter((message) => !message.hasBeenRead)
    .map((message) => message.otherUserId);

  const uniqueUnreadUserIds = [...new Set(unreadUserIds)];

  return (
    <ComponentWrapper style={{ padding: "60px" }}>
      <h1 className="text-center">{t("messages.header")}</h1>
      <>
        <Modal
          className="d-flex align-items-center"
          show={show}
          onHide={handleClose}
        >
          <Modal.Header closeButton>
            <Modal.Title> </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              {user.messageRecipient ? (
                <SendMessage
                  curReceiverId={curReceiverId}
                  messageRecipient={user.messageRecipient}
                  userType={user.userType}
                  fillColumn={true}
                  loadMessages={loadingMessages}
                />
              ) : null}
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              {t("messages.close")}
            </Button>
          </Modal.Footer>
        </Modal>
      </>
      <Row>
        <Col
          className={`d-flex flex-wrap align-items-end ${width >= 768 ? "justify-content-start" : "justify-content-center"}`}
        >
          <h6
            className="pt-2 pb-2 mb-4"
            style={{
              width: "90%",
              borderRadius: "20px",
              backgroundColor: dark ? theme.darkModePrimary : "#3EB1A6",
              color: dark ? theme.darkModeText : "white",
              textAlign: "center",
              overflowWrap: "break-word",
              cursor: "pointer",
            }}
            onClick={() => history.push("/")}
          >
            {t("messages.dashboard")}
          </h6>
        </Col>
        <Col
          className={`d-flex flex-wrap align-items-end ${width >= 768 ? "justify-content-start" : "justify-content-center"}`}
        >
          <h6
            className="pt-2 pb-2 mb-4"
            style={{
              width: "90%",
              borderRadius: "20px",
              backgroundColor: dark ? theme.darkModePrimary : "#3EB1A6",
              color: dark ? theme.darkModeText : "white",
              textAlign: "center",
              overflowWrap: "break-word",
              cursor: "pointer",
            }}
            onClick={handleShow}
          >
            {t("messages.send_messages")}
          </h6>
        </Col>
        <Col className="align-items-end">
          <div className="mb-4">
            <h6>{t("messages.select_receiver")}</h6>
            <MyCustomDropdown
              options={options}
              onChange={handleDropdownChange}
              uniqueUnreadUserIds={uniqueUnreadUserIds}
            />
          </div>
        </Col>
      </Row>
      {messagesDisplay}
    </ComponentWrapper>
  );
};

export default Messages;